import BaseApiService from './BaseApiService';

interface TaskData {
  [key: string]: any;
}

class SceneApiService extends BaseApiService {
  constructor() {
    super('api');
  }

  // Получение задачи по пользователю и уровню
  postTask(user: string, level: string): Promise<TaskData> {
    return this.POST('data_models', { user, level_name: level });
  }

  // Получение данных сцены по пользователю, попытке и уровню
  postAttemptSceneData(user: string, attempt: number | string, level: string): Promise<TaskData> {
    return this.POST('data_models_one', { user, id: attempt, level_name: level });
  }

  // Новый метод: данные сцены для конкретного персонажа
  postCharacterSceneData(
      characterId: number,
      attempt: number | string,
      dateOrLevel: string
  ): Promise<TaskData> {
    return this.POST('data_models_character', { characterId, attempt, dateOrLevel });
  }
}

export default new SceneApiService();
